export const ProductKometa = {
  title: 'Kometa UI Kit',
  slug: 'kometa',
  url: '/products/kometa',
  price: 'Free',
};
